import React, { useContext } from 'react'
import { ContentInner } from '../layout/Content'
import Sales from './components/sales/Sales'
import Inventory from './components/inventory/Inventory'
import Miscellaneous from './components/miscellaneous/Miscellaneous'
import { appContext } from '../../App'

function ReportsInner() {
  const app = useContext(appContext)

  /** Sales Report **/
  const show_sales_report = (app.client.signed_in === 'admin')
  ? true
  : (
    (app.client.signed_in.user_access.reports_sales_reports) && (
        (app.client.signed_in.user_access.reports_sales_reports_daily_sales) ||
        (app.client.signed_in.user_access.reports_sales_reports_monthly_sales) ||
        (app.client.signed_in.user_access.reports_sales_reports_yearly_sales) ||
        (app.client.signed_in.user_access.reports_sales_reports_receivables)
      )
    )

  /** Invenotory Report **/
  const show_inventory_report = (app.client.signed_in === 'admin')
  ? true : (
    (app.client.signed_in.user_access.reports_inventory_reports) && (
      (app.client.signed_in.user_access.reports_inventory_reports_products_inventory) ||
      (app.client.signed_in.user_access.reports_inventory_reports_out_of_stocks) ||
      (app.client.signed_in.user_access.reports_inventory_reports_products_sold) ||
      (app.client.signed_in.user_access.reports_inventory_reports_unmoving_products) ||
      (app.client.signed_in.user_access.reports_inventory_reports_price_list)
    )
  )

  return (
    <ContentInner>
      { (show_sales_report) ? <Sales /> : null }
      { (show_inventory_report) ? <Inventory /> : null }
      <Miscellaneous />
    </ContentInner>
  )
}

export default React.memo(ReportsInner)